var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDown = function SvgDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8 10.5a.5.5 0 0 0 .354-.146l4-4a.5.5 0 0 0-.708-.708L8 9.293 4.354 5.646a.5.5 0 1 0-.708.708l4 4A.5.5 0 0 0 8 10.5",
    clipRule: "evenodd"
  })));
};
export { SvgDown as ReactComponent };
export default __webpack_public_path__ + "22f32f8c6ad927f356d42359323654b7.svg";